import style from './RESTPlaygroundOpenButton.scss';
import * as React from 'react';
import { LOGGER_TYPES } from '../../../../../LoggerFactory/loggerTypes';
import { wixDocsTryItOutClick } from '../../../../../LoggerFactory/BiAnalyticsLogger/events';
import {
  getArticleNameFromHashPrefix,
  getCategoryName,
} from '../../../../../LoggerFactory/BiAnalyticsLogger/events/utils';
import { fromRelativeUrlToAbsoluteUrl } from '../../../../../../utils/locationUtils';
import { StoreContext } from '../../../../../appContext/StoreProvider';
import { LoggerContext } from '../../../../../appContext/LoggerProvider';
import { HashPrefixContext } from '../../../../HashPrefixProvider';
import { useLocation } from 'react-router';
import { Button } from '../../../../Layout/Button';

interface RESTPlaygroundOpenButtonProps {
  onOpenPlaygroundClick: () => void;
}

export const RESTPlaygroundOpenButton = ({
  onOpenPlaygroundClick,
}: RESTPlaygroundOpenButtonProps) => {
  const { store } = React.useContext(StoreContext);
  const { logger } = React.useContext(LoggerContext);
  const { hashPrefix } = React.useContext(HashPrefixContext);
  const location = useLocation();

  const sendTryItOutClickEventLog = () => {
    const categoryName = getCategoryName(location.pathname, store);
    logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(wixDocsTryItOutClick, {
      category_name: categoryName,
      article_name: getArticleNameFromHashPrefix(hashPrefix, categoryName),
      article_url: fromRelativeUrlToAbsoluteUrl(
        `/${hashPrefix}`,
        window.location.origin,
        store,
      ),
    });
  };

  return (
    <Button
      onClick={() => {
        onOpenPlaygroundClick();
        sendTryItOutClickEventLog();
      }}
      className={style.playgroundButton}
      size="tiny"
      dataHook="try-it-out-button"
    >
      Try It Out
    </Button>
  );
};
